
module.exports = {
  name: 'flipInY',
  'backface-visibility': 'visible !important',
  option: {
    duration: '1s',
    mode: 'both'
  },
  timeline: {
    from: {
      transform: 'perspective(400px) rotate3d(0, 1, 0, 90deg)',
      'animation-timing-function': 'ease-in',
      opacity: '0'
    },
    '40%': {
      transform: 'perspective(400px) rotate3d(0, 1, 0, -20deg)',
      'animation-timing-function': 'ease-in'
    },
    '60%': {
      transform: 'perspective(400px) rotate3d(0, 1, 0, 10deg)',
      opacity: '1'
    },
    '80%': {
      transform: 'perspective(400px) rotate3d(0, 1, 0, -5deg)'
    },
    to: {
      transform: 'perspective(400px)'
    }
  }
};



// WEBPACK FOOTER //
// ./lib/ctr-nodes/preset/animation/animate.css/flipInY.js